var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"StaffManage-list"},[_c('GlobalInfoBar',{attrs:{"title":"分类列表","content":"分类列表"}}),_c('GlobalChunk',{attrs:{"icon":"search","title":"筛选查询"}},[_c('div',{attrs:{"slot":"filter"},slot:"filter"},[_c('CategoryForm',{attrs:{"byRoleList":_vm.byRoleList}})],1),_c('CategoryTable',{attrs:{"byRoleList":_vm.byRoleList}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }